"use strict";
exports.__esModule = true;
var Image = require("./media/image");
exports.Image = Image;



//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/lib/modules/00-atoms/media.js
// module id = 70
// module chunks = 0